// src/layouts/AuthLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';

import './AuthLayout.css';

const AuthLayout = () => {
  return (
    <div id="auth">
      <div className="row h-100">
        <div className="col-lg-5 col-12 auth-left-column">
          <Outlet />
        </div>
        <div className="col-lg-7 d-none d-lg-block ps-0 pe-0">
          <div id="auth-right">
            <img src="/assets/images/logo-cirenio-white.svg" alt="Cirenio Logo" className="cirenio-logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
